import { Component } from '@angular/core';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { ControlPageSidebarCacheService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-sidebar-cache.service';
import { ControlPageStore } from '@pages/control-page/control-page-store.service';
import { FeedbackPopupService } from '@pages/control-page/feedback-popup.service';
import { WeatherForecastService } from '@pages/control-page/modules/weather-forecast/weather-forecast.service';
import { ControlPageService } from './control-page.service';

@Component({
  selector: 'app-control-page',
  templateUrl: './control-page.component.html',
  styleUrls: ['./control-page.component.scss'],
  providers: [
    ControlPageStore,
    ControlPageService,
    WeatherForecastService,
    ControlPageCardService,
    ControlPageSidebarCacheService,
    FeedbackPopupService,
  ],
})
export class ControlPageComponent {

  constructor(
    public feedbackPopupService: FeedbackPopupService,
  ) {}

}
